import './reviews.component.scss'

import HolyStars from 'holy-stars'
import { Application } from '../../helpers/app'

document.querySelectorAll('.review-stars').forEach(item => {
  new HolyStars({
    el: item,
    rate: item.dataset.rate || 5,
    size: 18,
    primaryColor: '#FFC13B',
    secondColor: '#fad5d5'
  })
})

Application.swiper().then(({ Swiper, Navigation }) => {
  Swiper.use([Navigation])
  new Swiper('.reviews-slider', {
    slidesPerView: 1,
    spaceBetween: 32,
    autoHeight: true,
    loop: true,
    navigation: {
      prevEl: '.reviews-nav[data-nav-prev]',
      nextEl: '.reviews-nav[data-nav-next]'
    },
    breakpoints: {
      992: {
        slidesPerView: 2
      }
    }
  })

  Application.lozad('.reviews-slider .lozad')
})
